export const audioBannerData = [
    {
      id: 1,
      title: "Harry Potter",
      audioType: "Audio",
      episodes: 13,
      genre: "Thriller",
      backgroundImage: "./images/home/harrycover.png"
    },
    {
      id: 2,
      title: "Chamber of Secrets",
      audioType: "Audio",
      episodes: 1,
      genre: "Thriller",
      backgroundImage: "./images/home/harrycover.png"
    },
    {
      id: 3,
      title: "Prisoner of Azkaban",
      audioType: "Audio",
      episodes: 13,
      genre: "Thriller",
      backgroundImage: "./images/home/harrycover.png"
    },
    {
      id: 4,
      title: "Goblet of Fire",
      audioType: "Audio",
      episodes: 13,
      genre: "Thriller",
      backgroundImage: "./images/home/harrycover.png"
    },
    {
        id: 5,
        title: "Order of the Phoenix",
        audioType: "Audio",
        episodes: 13,
        genre: "Thriller",
        backgroundImage: "./images/home/harrycover.png"
      },
      {
        id: 6,
        title: "Half-Blood Prince",
        audioType: "Audio",
        episodes: 13,
        genre: "Thriller",
        backgroundImage: "./images/home/harrycover.png"
      },
      {
        id: 7,
        title: "Deathly Hallows",
        audioType: "Audio",
        episodes: 13,
        genre: "Thriller",
        backgroundImage: "./images/home/harrycover.png"
      },
        {
        id: 8,
        title: "Fantastic Beasts",
        audioType: "Audio",
        episodes: 13,
        genre: "Thriller",
        backgroundImage: "./images/home/harrycover.png"
      },
        {
        id: 9,
        title: "Cursed Child",
        audioType: "Audio",
        episodes: 13,
        genre: "Thriller",
        backgroundImage: "./images/home/harrycover.png"
      },
         {
        id: 10,
        title: "Quidditch Through the Ages",
        audioType: "Audio",
        episodes: 13,
        genre: "Thriller",
        backgroundImage: "./images/home/harrycover.png"
      },
         {
        id: 11,
        title: "The Tales of Beedle the Bard",
        audioType: "Audio",
        episodes: 13,
        genre: "Thriller",
        backgroundImage: "./images/home/harrycover.png"
      },
         {
        id: 12,
        title: "Harry Potter: A History of Magic",
        audioType: "Audio",
        episodes: 13,
        genre: "Thriller",
        backgroundImage: "./images/home/harrycover.png"
      },
         {
        id: 13,
        title: "Harry Potter and Philosophy Stone",
        audioType: "Audio",
        episodes: 13,
        genre: "Thriller",
        backgroundImage: "./images/home/harrycover.png"
      },
  ];